import React from "react";
import coding from "./img/coding.png";
import marketing from "./img/maketing.png";
import skills from "./img/skill.png";
import problem from "./img/problem.png";
import "./css/CoursesMain.css";

function CoursesMain() {
  return (
    <div className="main courses-main">
      <div className="main-content">
        <div className="main-content-text">
          <p className="main-text course-text">
            Grow up your skills now <br /> and Be a true professional.
          </p>
          <span />
          <p className="desc">
            Check out our finest courses on <br />
            Programming, Digital Marketing and Soft Skills for students of
            colleges and schools. Each course is designed and customized
            accordingly to grasp effective knowledge &amp; skills in less time.
          </p>
        </div>
        <div className="main-content-img images">
          <img className="image" src={coding} alt="logo" />
          <p>Coding</p>
          <div className="image-second">
            <img className="image" src={marketing} alt="logo" />
            <p
              style={{
                textAlign: "center",
              }}
            >
              ← Digital Marketing <br />+ <br />
              Soft Skills →
            </p>
            <img className="image" src={skills} alt="logo" />
          </div>
          <p>Algorithms</p>
          <img className="image" src={problem} alt="logo" />
        </div>
      </div>
    </div>
  );
}

export default CoursesMain;
